import { Flex, Tag } from 'antd';
import { noCase } from 'change-case';
import cx from 'clsx';
import React from 'react';
import { ReasonTooltip } from '../../../pages/seller-center/products/manage-products/product-tooltips';
import { Icon, Tooltip } from '../index.js';
import styles from './index.module.scss';

const getBadgeStatus = (name = '') => {
  switch (noCase(name)) {
    case 'pending':
    case 'order confirmed':
    case 'partially accepted':
    case 'payment pending':
      return 'warning';
    case 'accepted':
    case 'settlement prepared':
    case 'paid':
    case 'enabled for seller':
      return 'success';
    case 'in transit':
    case 'confirmed':
    case 'dispatched':
    case 'verified':
      return 'blue';
    case 'rejected':
    case 'cancelled':
    case 'overdue':
      return 'error';
    case 'unanswered':
    case 'refund':
    case 'new':
      return 'orange';
    case 'ready for pickup':
      return 'purple';
    case 'completed':
    case 'delivered':
    case 'settled':
    case 'approved':
    case 'payment submitted':
    case 'active':
    case 'on vacation':
    case 'answered':
      return 'cyan';
    default:
      return 'default';
  }
};

export default function Status({ name, showToolTip, info, className, color, textColor, size, ...rest }) {
  return (
    <Tag
      color={color ? color : getBadgeStatus(name)}
      bordered={false}
      className={cx(styles.status, className, !!size && styles?.[size])}
      {...rest}
    >
      <Flex align="center" gap={4}>
        <span style={textColor ? { color: textColor } : {}}>{name}</span>
        {showToolTip && (
          <Tooltip
            title={<ReasonTooltip reason={info} />}
            overlayStyle={{
              minWidth: 'unset',
              maxWidth: 'unset',
            }}
            overlayInnerStyle={{
              maxHeight: '360px',
              overflowY: 'auto',
            }}
          >
            <Icon icon="BsInfoCircle" color={color ? color : getBadgeStatus(name)} iconSize="1em" />
          </Tooltip>
        )}
      </Flex>
    </Tag>
  );
}
